
import Confirmer from '@marketplace/components/forms/confirmer/confirmer.vue'
import TextInput from '@marketplace/components/forms/inputs/text-input.vue'
import GermanLogos from '@marketplace/components/logos/GermanLogos.vue'
import ImageCard from '@marketplace/components/signup/ds/image-card.vue'
import SignupMixin from '@marketplace/components/signup/retailer-signup-mixin.js'
import { OC_SIGNUP_RETURN_URL } from '@marketplace/config/localStorage.js'
import { RETAILER_CREATE_MUTATION } from '@marketplace/graphql/auth.js'
import {
    trackGQLErrors,
    trackVuelidateErrors,
} from '@marketplace/helpers/segment/errorTracking.js'
import {
    identifyAccountWithTraitsPromise,
    trackLoggedOut,
} from '@marketplace/helpers/segment/index.js'
import { EventBus } from '@marketplace/plugins/event-bus.js'
import Cookies from 'js-cookie'
import { email, minLength, required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

export default {
    components: {
        Confirmer,
        TextInput,
        GermanLogos,
        ImageCard,
    },

    mixins: [SignupMixin],

    props: {
        options: { type: Object, default: () => ({}) },
    },

    data() {
        return {
            isbusyConfirming: false,
            isConfirmed: false,
            form: {
                email: '',
                password: '',
            },
        }
    },

    computed: {
        ...mapGetters('global', ['globalFreeShippingAmount']),
        allFieldsFilled() {
            const { email, password } = this.form
            return email && password
        },
    },

    validations() {
        return {
            form: {
                email: { required, email },
                password: { required, minLength: minLength(6) },
            },
        }
    },

    mounted() {
        trackLoggedOut('Retailer Signup - Open Modal')
    },

    methods: {
        logIn() {
            EventBus.$emit('modal-open', 'modal-login')
        },

        checkIfValid() {
            this.$v.$touch()

            if (!this.$v.$invalid && !this.isbusyConfirming) {
                this.isbusyConfirming = true

                const basePayload = {
                    email: this.form.email,
                    password: this.form.password,
                    country: window.Store.country.toUpperCase(),
                    signupIntent: 'marketplace',
                }

                const payload = {
                    ...basePayload,
                    ...this.options,
                }

                this.$apollo
                    .mutate({
                        mutation: RETAILER_CREATE_MUTATION,
                        variables: payload,
                    })
                    .then((res) => {
                        const resourceName = 'retailerCreate'

                        if (!res.data[resourceName].userErrors?.length) {
                            this.isConfirmed = true

                            window.analytics.reset() // reset analytics, also identify

                            delete payload.password // lets stay safe
                            const account = res.data[resourceName].account

                            identifyAccountWithTraitsPromise({
                                id: account.databaseId,
                                accountId: account.databaseId,
                                realUserId: account.userId,
                                createdAt: account.createdAt,
                                type: 'retailer',
                                locale: window.Store.locale,
                            })
                                .then(() => {
                                    this.handleRetailerSignupSuccess()
                                })
                                .catch((error) => {
                                    this.$sentry.withScope((scope) => {
                                        scope.setTag('operation', 'identify')

                                        this.$sentry.captureException(error)
                                    })

                                    this.handleRetailerSignupSuccess()
                                })
                        } else {
                            this.isbusyConfirming = false
                            this.userErrors = res.data[resourceName].userErrors
                            trackGQLErrors(this.userErrors, this.$data)
                        }
                    })
                    .catch((e) => {
                        this.isbusyConfirming = false
                        console.warn(e)
                    })
                    .finally(() => {
                        this.buttonDisabled = false
                    })
            } else {
                trackVuelidateErrors(this.$v)
            }
        },
        handleRetailerSignupSuccess() {
            const redirectUrl =
                this.$page.currentRouteName === 'storefront-signup' ||
                this.$page.currentRouteName === 'store-slug-signup'
                    ? window.location.href.split('?')[0].replace('/signup', '')
                    : window.location.href

            localStorage.setItem(OC_SIGNUP_RETURN_URL, redirectUrl)

            Cookies.set(`oc-rs--trackCompleted`, redirectUrl, {
                expires: 3000,
            })
            setTimeout(() => {
                // timeout so the success animation has a chance to complete
                window.location.href = '/signup/retailers'
            }, 1000)
        },
    },
}
